<template>
  <div class="tab_box">
    <span class="btn set_head_btn" @click.stop="dialogFormVisible=true" v-if="!setHeadBtn"> <i class="iconfont">&#xe66d;</i> 设置表头</span>

    <!-- 设置表头 -->
    <el-dialog title="设置表头" customClass="w500 set_table_head" :visible.sync="dialogFormVisible" :modal-append-to-body='false' v-dialogDrag>
      <el-checkbox :min="1" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="checkedTabHead" @change="handleCheckedCitiesChange">
        <el-checkbox v-for="item in columns" :label="item.field" :key="item.field" :disabled="item.need">{{item.title}}</el-checkbox>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click.stop="selectTabHead">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 列表 -->
    <el-table
      v-loading="$store.state.isLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.8)"
      ref="multipleTable"
      :data="tabList"
      :height="height"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
      @current-change="handleCurrentChange"
      @row-dblclick="dbTab"
      border
      highlight-current-row
      style="width: 100%">
      <!-- 多选 -->
      <el-table-column
        v-if="tabCheckbox"
        type="selection"
        width="55">
      </el-table-column>
      <!-- 单选-->
      <el-table-column
        v-else
        type="index"
        label="序号"
        width="50">
      </el-table-column>

      <template v-for="(item,index) in tabColumns">
        <el-table-column
        :key="index"
       :sortable="item.sortable"
       :prop="item.field"
       :label="item.title"
       :width="item.width"
       :formatter="item.formatter"
         ></el-table-column>
      </template>

    </el-table>


    <el-pagination
      class="pages_box"
      v-if="pages > 1"
      @size-change="handleSizeChange"
      @current-change="currentChange"
      :page-sizes="[10, 20,50, 100]"
      :page-size="fromData.pageSize"
      layout="prev, pager, next, jumper, sizes ,total"
      :total="total">
    </el-pagination>

</div>

</template>

<script>
  export default {
    props:{
      setHeadBtn:Boolean,
      tabList:Array,
      columns:Array,
      selectedList:Array,//已选数组
      tabHeight:String,
      tabCheckbox:Boolean,//TAB是否有复选框
      total:Number,//总条数
      pages:Number,//总页数
      fromData:Object,
      tabName:String,//当前表格名字，用于表头缓存
    },
    data() {
      return {
        dialogFormVisible:false,
        tabColumns:[],
        checkAll: false,
        checkedTabHead: [],//选中的表头
        isIndeterminate: true,
        height:300,
        multipleSelectionAll: [],   // 所有选中的数据包含跨页数据
        multipleSelection: [],   // 当前页选中的数据
      }
    },
    created(){
      this.getTabhead();
      this.getTabHeight();
    },
    watch:{
      selectedList:{
        handler:function(val){
          this.tabList.forEach((item,index)=>{
            let isTrue = val.find(v=>v.selectId===item.selectId);
            if(isTrue){
              this.$refs.multipleTable.toggleRowSelection(item,true);
            }else{
              this.$refs.multipleTable.toggleRowSelection(item,false);
            }
          });
        },
        deep:true
      },
      tabList:{
        handler:function(val){
          val.forEach((item,index)=>{
            /* let isTrue = this.selectedList.find(v=>v.selectId === item.selectId);
            if(isTrue){
              this.$refs.multipleTable.toggleRowSelection(item,true);
            }else{
              this.$refs.multipleTable.toggleRowSelection(item,false);
            } */
          });
        },
        deep:true
      },
    },
    updated:function(){
      let _this = this;
      this.getTabHeight();
      $(window).resize(()=>{
        _this.getTabHeight();
      });
    },
    methods: {
      //获取表格头部
      getTabhead(){
        this.checkedTabHead = [];
        this.tabColumns = [];
        //1. 提取已配置好的显示表头
        let isHead = localStorage.getItem(this.tabName);
        if(isHead){//存存就读取
          this.checkedTabHead = JSON.parse(isHead);
        }else{//不存在就获取,默认全选
          this.columns.forEach((item)=>{
            this.checkedTabHead.push(item.field);
          });
        }
        //2.动态设置显示的表头
        this.handlerTabHeader();
      },
      //动态设置显示的表头
      handlerTabHeader(){
        this.columns.forEach((item)=>{
          let is = this.checkedTabHead.findIndex(v => v === item.field);
          if(is != -1) this.tabColumns.push(item);
        });
        localStorage.setItem(this.tabName,JSON.stringify(this.checkedTabHead));
      },
      //确定所先
      selectTabHead(){
        this.tabColumns = [];
        //2.动态设置显示的表头
        this.handlerTabHeader();
        this.dialogFormVisible = false;

        /* let temp = this.columns.map((item)=>{
          let is = this.checkedTabHead.findIndex(v=>v === item.field);
          if(is != -1){
            this.tabColumns.push(item);
          }
        }); */
      },
      //改变全选/全不选
      handleCheckAllChange(val) {
        let temp = [];
        this.checkedTabHead = [];
        if(val){//全选
          this.columns.forEach((item) => {
            this.checkedTabHead.push(item.field);
          });
        }else{//非全选
          this.columns.forEach((item) => {
            if(item.need){
              this.checkedTabHead.push(item.field);
            }
          });
        }
        this.isIndeterminate = false;
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.columns.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.columns.length;
      },

      //动态获取高度
      getTabHeight(){
        if(this.tabHeight){
          this.height = this.tabHeight;
        }else{
          //let pagesHeight = $('.pages_box').height() ? 50 : 20;
          this.height = this.$myfn.resetRigthSize();
        }
        console.log(this.height,'== 当前表格的高度 ==');
      },
      tableRowClassName({row, rowIndex}) {
        row.rowIndex = rowIndex
        if(row.delId === '0011'){
          return "del-row";
        }else{
          return '';
        }
      },
      //取消选择
      cancelSelect(){
        this.tabList.forEach((item,index)=>{
          let isTrue = this.selectedList.find(v=>v.selectId===item.selectId);
          if(isTrue){
            this.$refs.multipleTable.toggleRowSelection(item,true);
          }else{
            this.$refs.multipleTable.toggleRowSelection(item,false);
          }
        });
      },
      //选中
      handleSelectionChange(val) {
        console.log(this.multipleSelectionAll,'所有已选');
        this.multipleSelection = val;
        this.$emit('getSelect',val);
      },
      handleClick(row) {
        //console.log(row);
      },
      //翻页时记录所选
      changePageCoreRecordData(){
        if(this.multipleSelectionAll.length){
          this.multipleSelectionAll.forEach((item)=>{
          });
        }else{
          this.multipleSelectionAll = this.multipleSelection;
        }
      },
      //页码改变时
      currentChange(currentPage){
        this.changePageCoreRecordData();
        this.$emit('currentChange',currentPage);
      },

      //单击选中这条数据
      handleCurrentChange(val) {
        // console.log(val);
        // this.$store.state.cache.productOrderNos = val.productOrderNo
        // this.$store.state.cache.productOrderId = val.productOrderId

        // console.log(this.$store.state.cache.productOrderNos)
        this.currentRow = val;
        this.$emit('selectSdata',val);
      },
      
      //双击
      dbTab(val){
        this.$emit('dbClick',val);
        //console.log(val,'我被双击了');
      },

      //页码条数改变
      handleSizeChange(val){
        this.$emit('changePages',val);
        //console.log(val,'=====');
      }

    }
  }
</script>
